// React
import { Fragment, useContext } from "react"

// Contexts
import { AccountContext } from "contexts"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

// Types
import type { SelectOptionType } from "types"
import type { FormType } from "../utils"

// Utils
import { convertNumber, useCoaByCode } from "utils"

type BodyProps = {
  showDateColumn?: boolean
  showIdColumn?: boolean
  showMemoColumn?: boolean
}

export function Body({
  showDateColumn = true,
  showIdColumn = true,
  showMemoColumn = true
}: BodyProps): JSX.Element {
  // Hooks
  const coaCode = useCoaByCode("LA09")
  const { data } = useContext(AccountContext)

  // Form
  const { control } = useFormContext<FormType>()
  const trx_code = useWatch({
    control,
    name: "trx_code"
  })
  const transaction_date = useWatch({
    control,
    name: "transaction_date"
  })
  const coa_id = useWatch({
    control,
    name: "coa_id"
  })
  const memo = useWatch({
    control,
    name: "memo"
  })
  const amount = useWatch({
    control,
    name: "amount"
  })

  // Vars
  const coa: SelectOptionType | undefined = data.find(
    (item) => item.value === coa_id
  )

  if (coa_id && amount) {
    return (
      <Fragment>
        <tr>
          {showDateColumn ? (
            <td className="text-center">
              {moment(transaction_date).format("DD/MM/YYYY")}
            </td>
          ) : null}
          {showIdColumn ? <td className="text-center">{trx_code}</td> : null}
          <td>{coaCode.data}</td>
          {showMemoColumn ? <td>{memo}</td> : null}
          <td className="text-right">{convertNumber(amount).intoCurrency}</td>
          <td className="text-right text-error"></td>
        </tr>

        <tr>
          {showDateColumn ? (
            <td className="text-center">
              {moment(transaction_date).format("DD/MM/YYYY")}
            </td>
          ) : null}
          {showIdColumn ? <td className="text-center">{trx_code}</td> : null}
          <td>{coa?.label}</td>
          {showMemoColumn ? <td>{memo}</td> : null}
          <td className="text-right"></td>
          <td className="text-right text-error">
            {convertNumber(amount).intoCurrency}
          </td>
        </tr>
      </Fragment>
    )
  }

  return (
    <tr>
      <td colSpan={6} />
    </tr>
  )
}
